module.exports = __webpack_public_path__ + "img/orbit.d12fdbdf.png";